import CardDefault from "./CardDefault";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <CardDefault image={"./dashboard/1.jpg"} link={"/Intaglio"} title={t("Intaglio")} description={t("IntaglioDescr")} />
          <CardDefault image={"./dashboard/2.jpg"} link={"/Compressione"} title={t("Compressione")} description={t("CompressioneDescr")} />
          <CardDefault image={"./dashboard/3.jpg"} link={"/TraveTrave"} title={t("TraveTrave")} description={t("TraveTraveDescr")} />
          <CardDefault image={"./dashboard/4.jpg"} link={"/AncoraggioBase"} title={t("AncoraggioBase")} description={t("AncoraggioBaseDescr")} />
          <CardDefault image={"./dashboard/5.jpg"} link={"/GiuntoRipristino"} title={t("GiuntoRipristino")} description={t("GiuntoRipristinoDescr")} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <CardDefault image={"./dashboard/6.jpg"} link={"/StaffaT"} title={t("StaffaT")} description={t("StaffaTDescr")} />
          <CardDefault image={"./dashboard/7.jpg"} link={"/RinforzoTrave"} title={t("RinforzoTrave")} description={t("RinforzoTraveDescr")} />
          <CardDefault image={"./dashboard/8.jpg"} link={"/FissaggioCoibente"} title={t("FissaggioCoibente")} description={t("FissaggioCoibenteDescr")} />
          {/* <CardDefault image={"./dashboard/9.jpg"} link={"/SolaioCollaborante"} title={t("SolaioCollaborante")} description={t("SolaioCollaboranteDescr")} /> */}
        </div>
      </div>
    </>
  );
};
export default Home;
